import { Action } from '@ngrx/store';
import { ApsAssignedList } from 'src/app/models/aps-assigned-list';

export enum ApsAssignedActionTypes {
    FetchApsAssigned = '[APS] Fetch Aps Assigned List',
    LoadApsAssigned = '[APS] Load Aps Assigned List'
}

export class FetchApsAssigned implements Action {
    readonly type = ApsAssignedActionTypes.FetchApsAssigned;
    constructor() { }
}

export class LoadApsAssigned implements Action {
    readonly type = ApsAssignedActionTypes.LoadApsAssigned;
    constructor(public payload: Array<ApsAssignedList>) { }
}


export type ApsAssignedAction =
  | FetchApsAssigned
  | LoadApsAssigned
;
